import React from 'react'
import Modal from '../../modals/wrapper'
import BusyModal from '../../modals/busy'
import useCourse from '../../../hooks/use-course'
import { StudentSelector } from './student-selector'
import { EnrolleesList } from './enrollees-list';

const ExperienceEnrollmentManagementModal = ({
    experienceId,
    onClose = () => {}
}) => {
    const { course, isBusy: isLoading } = useCourse({ id: experienceId })

    if (isLoading) {
        return (<BusyModal />)
    }

    return (
        <Modal closeButton onHide={onClose} closeStyle={{ color: 'white' }} backdrop="static" size='lg'>
            <Modal.Header>Enrollment Management</Modal.Header>
            <div
                style={{
                    padding: '20px',

                }}
            >
                <StudentSelector courseId={course.id} />
                <EnrolleesList courseId={course.id} />
            </div>
        </Modal>
    )
}

export default ExperienceEnrollmentManagementModal